import React from 'react';
import { Box } from '@mui/material';
import { ForceLightTheme } from '../../context/ThemeContext';
import TopTicker from './TopTicker';
import Navbar from './Navbar';
import Footer from './Footer';

// The public marketing site is light-only (the authed shell keeps its theme toggle).
// Order matters: the live ticker sits at the very top, ABOVE the sticky header.
function PublicLayout({ children }) {
  return (
    <ForceLightTheme>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#FFFFFF' }}>
        <TopTicker />
        <Navbar />
        <Box component="main" sx={{ flex: 1 }}>
          {children}
        </Box>
        <Footer />
      </Box>
    </ForceLightTheme>
  );
}

export default PublicLayout;
